import { render, staticRenderFns } from "./validatorSelect.vue?vue&type=template&id=0afd2d0e&scoped=true"
import script from "./validatorSelect.vue?vue&type=script&lang=js"
export * from "./validatorSelect.vue?vue&type=script&lang=js"
import style0 from "./validatorSelect.vue?vue&type=style&index=0&id=0afd2d0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afd2d0e",
  null
  
)

export default component.exports